import { useMutation } from '@tanstack/react-query';

import type { MutationResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export type AssignServicesData = {
  client_id: number;
  service_ids: number[];
  use_after_assign: boolean;
};

export const useDeleteBookingMemberMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; toDeposit?: boolean }) =>
      HttpClient.request<MutationResponse>({
        method: 'DELETE',
        url: params.url,
        data: {
          booking_member: {
            to_deposit: params.toDeposit || false,
          },
        },
      }),
  });

export const useAssignServicesMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; data: AssignServicesData }) =>
      HttpClient.request<MutationResponse>({
        method: 'POST',
        url: params.url,
        data: params.data,
      }),
  });

export const useTransferEventMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; booking_event_id: number }) =>
      HttpClient.request<MutationResponse>({
        method: 'POST',
        url: params.url,
        data: { booking_event_id: params.booking_event_id },
      }),
  });
